import ImageOne from "../canadaunis/ALGONQUIN.png";
import ImageTwo from "../canadaunis/BCIT.jpeg";
import ImageThree from "../canadaunis/CENTENNIAL.jpeg";
import ImageFour from "../canadaunis/Columbia College.jpeg";
import ImageFive from "../canadaunis/J-Addison.png";
import ImageSix from "../canadaunis/NC.png";
import ImageSeven from "../canadaunis/OntarioTech.jpeg";
import ImageEight from "../canadaunis/UCW.avif";
import ImageNine from "../canadaunis/Uni Windsor.jpg";

const universities = [
  // { id: 1,img: ImageOne, name: "", description:"", summary:"", phone:"", email:"", address:"", coursesLink:"", },
  { id: 1, img: ImageOne, name: "ALGONQUIN COLLEGE" },
  { id: 2, img: ImageTwo, name: "BRITISH COLUMBIA INSTITUTE OF TECHNOLOGY" },
  { id: 3, img: ImageThree, name: "CENTENNIAL COLLEGE" },
  { id: 4, img: ImageFour, name: "Columbia College" },
  { id: 5, img: ImageFive, name: "J.Addison School" },
  { id: 6, img: ImageSix, name: "Niagara College Canada" },
  { id: 7, img: ImageSeven, name: "OntarioTech UNIVERSITY" },
  { id: 8, img: ImageEight, name: "UNIVERSITY CANADA WEST" },
  { id: 9, img: ImageNine, name: "University of Windsor" },
];

export default universities;
